import { db } from "common/config/Firebase"

const clientCollection = db.collection('clients')
const paramCollection = db.collection('params').doc('clients')

export const saveClient = client => {
    try {
        return clientCollection.doc(client.id)
        .set(client, { merge: true })
        .catch(err => console.log("Cliente error " + JSON.stringify(client)))
    } catch (err) {
        console.log(err)
        console.log("Cliente error " + JSON.stringify(client))
    }
}

export const getClientParams = () => {
    return paramCollection.get().then(data => data.data())
}

export const updateClientParams = params => {
    return paramCollection.update(params)
}

export const getClientsSnapshot = callback => {
    return clientCollection.onSnapshot(callback)
}

export const deleteClient = id => {
    return clientCollection.doc(id).delete()
}

export const findClientByDNI = dni => {
    return clientCollection.doc(dni).get()
}

export const findClients = () => {
    return clientCollection.get()
}
